import { toDayKey } from "./stats";

// Spaced-repetition interval ladder (in days). Each successful review moves the
// problem to the next, longer interval; a shaky review drops back to the first.
export const REVISE_LADDER = [1, 3, 7, 16, 35];

// Local-time YYYY-MM-DD for "today".
export function todayKey() {
  return toDayKey(new Date());
}

// YYYY-MM-DD that is `days` after the given base (date, day-key, or now).
export function addDaysKey(base, days) {
  const d = base instanceof Date ? new Date(base) : base ? new Date(base) : new Date();
  d.setDate(d.getDate() + (days || 0));
  return toDayKey(d);
}

// A problem is "due" when it is in the revise set and either has no scheduled
// date (legacy / just-marked) or its next-review day has arrived.
export function isDue(q, tkey) {
  if (!q || !q.Revise) return false;
  const today = tkey || todayKey();
  return !q.ReviseAt || q.ReviseAt <= today;
}

// Walk every topic/question and split the revise set into due vs upcoming.
// Each item carries the topic/problem indices so callers can mutate via updateData.
export function collectRevise(questionData, tkey) {
  const today = tkey || todayKey();
  const due = [];
  const upcoming = [];
  (questionData || []).forEach((topic, ti) => {
    (topic.questions || []).forEach((q, pi) => {
      if (!q || !q.Revise) return;
      const item = { ti, pi, topicName: topic.topicName, q };
      if (isDue(q, today)) due.push(item);
      else upcoming.push(item);
    });
  });
  due.sort((a, b) => (a.q.ReviseAt || "").localeCompare(b.q.ReviseAt || ""));
  upcoming.sort((a, b) => (a.q.ReviseAt || "").localeCompare(b.q.ReviseAt || ""));
  return { due, upcoming, total: due.length + upcoming.length };
}

// Convenience: how many problems are due for revision right now.
export function dueCount(questionData, tkey) {
  return collectRevise(questionData, tkey).due.length;
}

// The patch to apply after reviewing a problem.
//   outcome "good"  -> advance one rung on the ladder
//   outcome "again" -> reset to the first (shortest) interval
export function scheduleNext(stage, outcome) {
  const cur = typeof stage === "number" && stage > 0 ? stage : 0;
  const ns = outcome === "good" ? Math.min(cur + 1, REVISE_LADDER.length - 1) : 0;
  return {
    Revise: true,
    ReviseStage: ns,
    ReviseAt: addDaysKey(new Date(), REVISE_LADDER[ns]),
  };
}

// The patch that removes a problem from the revise set entirely.
export function stopRevising() {
  return { Revise: false, ReviseStage: 0, ReviseAt: null };
}
